import { Skeleton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TimeSinceCreatedText = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: theme.palette.text.secondary,
  whiteSpace: 'pre-wrap',
}));

export const ThreadPostSkeleton = styled(Skeleton)(({ theme }) => ({
  height: 100,
  marginTop: theme.spacing(2),
  marginRight: 'auto',
  marginLeft: 'auto',
  width: '100%',
}));
